import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Button,
  FormControl,
  Typography,
  MenuItem,
  InputLabel,
  Drawer,
  TextField,
  Slider,
  Radio,
  RadioGroup,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
  Autocomplete,
  Dialog,
  DialogContent,
  FormLabel,
  CircularProgress,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import filter from "../../../assets/Project_Images/Icons/filter.png";
import clsx from "clsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs, { Dayjs } from "dayjs";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  CancelOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  WestOutlined,
} from "@mui/icons-material";
import { ErrorMessage, Form, Formik, useFormik, useFormikContext } from "formik";
import * as Yup from "yup";
import {
  APiGetTimeSelection,
  ApiBundleAllocations,
  ApiGetAllocationCriteriaDetails,
  ApiGetEntityType,
  ApiGetNewBrief,
  ApiGetQuiz,
  ApiGetStates,
  ApiSubmitQuiz,
  SearchName,
  applyTasks,
  fetchAllocations,
  getVisitTimes,
} from "../../../apiService/Core/Apicall.tsx";
import { DatePicker } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import Loading from "../../Loader/Loading.tsx";
import { AppDispatch, RootState } from "../../../Redux/Store.tsx";
import { findData, setData } from "../../../Redux/GetTimeSlice.tsx";
import sad from "../../../assets/Project_Images/sad (2).png";
import greenmarker from "../../../assets/Project_Images/Icons/greenmarker.png";
import { data, useLocation, useNavigate } from "react-router-dom";
import { fetchClientList } from "../../../Redux/clientSlice.tsx";
import { fetchBusinessList } from "../../../Redux/businessSlice.tsx";
import BulkAllocation from "./BulkAllocation.tsx";
import { toast } from "react-toastify";
import { GoogleMap, InfoWindow, LoadScript, Marker } from '@react-google-maps/api';
import { setSelectedMonth } from "../../../Redux/MonthSlice.tsx";
import ALDI from '../../../assets/Project_Images/Aldi_logo.png'
import BLOOMS from '../../../assets/Project_Images/Blooms_logo.png'
import MM from '../../../assets/Project_Images/MM_logo.png'
import ReadBrief from "./ReadBrief.tsx";


const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  borderWidth: "5px",
  width: 22,
  height: 22,
  borderColor: "green",
  boxShadow:
    "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  // backgroundColor: '#f5f8fa',
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px solid #ADB792",
    outlineOffset: 2,
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#7C9FB2",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,100%,0%,.1),hsla(0,100%,0%,0))",
  "&::before": {
    display: "block",
    width: 22,
    height: 22,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
});

const CustomSlider = styled(Slider)({
  width: "95%",
  color: "#D6D8C8", // Light track color
  height: 4,
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "white", // Main thumb color
    border: "6px solid #7C9FB2", // Inner white dot effect
    boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
    "&:hover, &.Mui-focusVisible": {
      // boxShadow: "0px 0px 8px rgba(0,0,0,0.5)",
    },
  },
  "& .MuiSlider-track": {
    height: 4,
    borderRadius: 3,
    backgroundColor: "transparent", // **Unfilled progress**
  },
  "& .MuiSlider-rail": {
    height: 4,
    opacity: 1,
    borderRadius: 3,
    backgroundColor: "#7C9FB25A", // White/Gray base rail
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#7C9FB2",
    height: 12,
    width: 12,
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
  },

  "& .MuiSlider-valueLabel": {
    backgroundColor: "white",
    color: "black",
    position: "absolute",
    top: "100%",
    transform: "translate(0px ,11px)",
  },
  "& .MuiSlider-markLabel": {
    color: "black",
  },
});

function BpRadio(props: any) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

interface FormValues {
  location: string;
  filterOption: string;
  range: string;
  venue: string;
  venueId: number;
}


function ApplyTask() {


  const [selectedId, setSelectedId] = useState<number | null>(null);
  const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
  // const [selectedId, setSelectedId] = useState<number | null>(window.innerWidth <= 576 ? null : 0);
  const [openFilter, setOpenFilter] = useState(false);
  const autocompleteRef = useRef<any>(null);
  const [entitytypelist, setentitytypelist] = useState<any>([])
  const [selectedentitytype, setselectedentitytype] = useState<any>()
  const [statelist, setstatelist] = useState<any>([])
  const [searchvenue, setsearchvenue] = useState<any>('')
  const [selectedstate, setselectedestate] = useState<any>()
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedmonth, setSelectedmonth] = useState<Dayjs>(dayjs(defaultMonth));
  const [venueList, setVenueList] = useState<
    { venueId: string; venueName: string }[]
  >([]);
  const [filteredVenues, setFilteredVenues] = useState<
    { venueId: string; venueName: string }[]
  >([]);
  const [location, setLocation] = useState<{
    latitude: number;
    longitude: number;
  }>();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const dispatch = useDispatch();
  const [totalallocation, setAllocation] = useState<any>();
  const [showfilter, setshowfilter] = useState<string>("");
  const [PostalCode, setPostalCode] = useState<string>("");
  const [showkm, setshowkm] = useState<string>("");
  const [OpenDialog, setOpenDialog] = useState<boolean>(false);
  const [OpenBriefDialog, setOpenBriefDialog] = useState<boolean>(false);
  const [OpenNewBriefDialog, setOpenNewBriefDialog] = useState<boolean>(false);
  const [OpenNewBriefReadDialog, setOpenNewBriefReadDialog] = useState<boolean>(false);
  const [isConfirmApply, setisConfirmApply] = useState<boolean>(false);
  const [OpenQuiz, setOpenQuiz] = useState<boolean>(false);
  const [IsQuizSubmitted, setIsQuizSubmitted] = useState<boolean>(false);
  const locations = useLocation();
  // const pathValue = locations.pathname.split("/")[2] || '';
  const [alignment, setAlignment] = React.useState('individual');
  const [showvenue, setshowvenue] = useState<string>("");
  const loading = useSelector((state: any) => state.loader.isLoading);
  const applyfilters: Record<string, any> = {};
  const [QuizList, setQuizList] = useState<any[]>([])
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [CorrectAnswer, setCorrectAnswer] = useState<number>(0)
  const mapRef = useRef<any>(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);
  const [hoveredMarkerIndex, setHoveredMarkerIndex] = useState<any>(null);

  const visittime = useSelector((state: RootState) => state.counter.data);
  const filtervalue = useSelector(
    (state: RootState) => state.counter.filterData
  );
  const { clientList, error } = useSelector((state: RootState) => state.client);
  const [selectedClient, setselectedClient] = useState<string>('all');
  const [allocationCriteria, setAllocationCriteria] = useState<any>();
  // const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const scrollContainerRef = useRef(null);
  const LIMIT = 50;
  const currentOffsetRef = useRef(0);
  const isFirstLoadRef = useRef(true); // ADD THIS at the top with other refs
  const [openPicker, setOpenPicker] = useState(false);
  const [reloadFlag, setReloadFlag] = useState(false);
  const [totalmapallocations, settotalmapallocations] = useState<any[]>([])
  const [selectedbundletask, setselectedbundleTask] = useState<any>(null)
  // const [dateCriteria, setDateCriteria] = useState<any>([]);
  const [fulladdress, setfulladdress] = useState<any>([]);
  const [newBrief, setNewBrief] = useState<any>()
  const [quizType, setQuizType] = useState<any>()
  const [openInfo, setOpenInfo] = useState<boolean>(false)
  // const hasFetchedRef = useRef(false);


  const containerStyle = {
    width: '100%',
    height: 'calc(100vh - 290px)'
  };



  useEffect(() => {
    setHoveredMarkerIndex(null)
    if (alignment === 'map') {
      // formik.setFieldValue("latitude", "");
      // formik.setFieldValue("longitude", "");
      // formik.setFieldValue("location", "");
      settotalmapallocations(totalallocation?.data)
      fetchbundleallocation()
      if (formik.values?.location) getallocation()
    }
    else {
      settotalmapallocations([])
    }
  }, [alignment])

  useEffect(() => {
    if (alignment === 'map') {
      settotalmapallocations([])
      fetchbundleallocation()
      getallocation(0, false, true)
    }
  }, [selectedmonth])

  const handleCallAnotherCriteria = async (item: any, isNeedToHideWeekend: boolean, isNeedToHideNonWeekend: boolean) => {
    try {
      const data = `?allocationId=${item.allocationId}&venueId=${item?.venueId}&jobMonth=${item?.jobMonth}&jobYear=${item?.jobYear}&isWeekDayJob=${isNeedToHideWeekend}&isWeekendDayJob=${isNeedToHideNonWeekend}`
      const res = await APiGetTimeSelection(data)
      if (res?.status) {

        setTimeout(() => {
          dispatch(
            findData(
              res?.visitTimeList?.map(Number)
            )
          );
        }, 100);
        // setDateCriteria(res?.data)
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }
  }

  const fetchbundleallocation = async (data: any = null) => {
    try {
      let params: any = {};

      if (data) {
        params = data; // send external data directly
      } else {
        // build applyfilters normally
        applyfilters.isUseForRunningAllocation = true;
        applyfilters.jobYear = selectedmonth.year();
        applyfilters.jobMonth = selectedmonth.month() + 1;
        applyfilters.userId = userData.userId;

        if (formik.values.filterOption == "myHome" && !selectedstate) {
          Object.assign(applyfilters, { nearByHome: true });
        }

        if (!selectedstate &&
          (formik.values.filterOption == "nearMe" || formik.values.filterOption == "manual")
        ) {
          Object.assign(applyfilters, { nearBy: true });
        }

        if (selectedentitytype) {
          applyfilters.entityTypeId = selectedentitytype;
        }

        if (selectedstate) {
          applyfilters.state = selectedstate;
        }

        if (selectedClient !== "all") {
          applyfilters.allocationClientGroup = selectedClient;
        }

        if (formik.values.venue.length === 0 && !selectedstate) {
          applyfilters.kilometerRange = formik.values.range;
        } else if (formik.values.venue.length > 0) {
          applyfilters.venueId = formik.values.venueId;
        }

        if (
          formik.values.filterOption === "nearMe" ||
          formik.values.filterOption === "manual"
        ) {
          Object.assign(applyfilters, {
            latitude: location?.latitude,
            longitude: location?.longitude,
          });
        }

        params = applyfilters;
      }

      const response = await ApiBundleAllocations(params)
      settotalmapallocations((prev: any) => [
        ...(Array.isArray(prev) ? prev : []),
        ...response.data.flatMap((item: any) => item.allocations || [])
      ]);
    } catch (error: any) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
    }
  }

  // console.log("Map Allocations", totalmapallocations)
  useEffect(() => {
    if (clientList && !selectedClient) {
      setselectedClient(clientList[2]?.clientGroupName)
    }
  }, [clientList])


  const center = {
    lat: Number(location?.latitude ?? userData.latitude),
    lng: Number(location?.longitude ?? userData.longitude)
  };
  const [mapCenter, setMapCenter] = useState(center);
  const [markerPosition, setMarkerPosition] = useState(center);
  const navigate = useNavigate();
  const marks = [
    { value: 0, label: "0 km" },
    { value: 300, label: "300 km" },
  ];
  const initialValues: FormValues = {
    location: "",
    filterOption: "myHome",
    range: "20",
    venue: "",
    venueId: 0,
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    if (newAlignment === null) return;
    if (newAlignment !== 'map') {
      setselectedbundleTask(null)
    }
    setAlignment(newAlignment);

  };

  useEffect(() => {
    setSelectedmonth(dayjs(defaultMonth))
  }, [defaultMonth])

  // const fetchData = async () => {
  //     try {

  //         const response = await getVisitTimes();
  //         console.log('Get Visited Time', response.data);

  //         dispatch(setData(response.data));
  //     } catch (error) {
  //         console.error("Error fetching visit times:", error);
  //     }
  // };

  // useEffect(() => {
  //     fetchData()
  // }, [dispatch])

  const appdispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!selectedClient) {
      setselectedClient(clientList[2]?.clientGroupName)
    }
  }, clientList)

  useEffect(() => {
    appdispatch(fetchClientList());
    appdispatch(fetchBusinessList(selectedClient));
  }, [appdispatch, selectedClient]);

  const validationSchema = Yup.object({
    location: Yup.string().when([], {
      is: () => formik.values.filterOption === "manual",
      then: (schema) => schema.required("Location is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const onSubmit = (values: FormValues) => {
    alignment === 'individual' && getallocation();
    alignment === "bulk" &&
      setReloadFlag((prev) => !prev)

    setFilteredVenues(venueList);
  };

  const handlesaveFilter = () => {
    // setHasMore(filteredData.length >= LIMIT);
    setshowfilter(formik.values.filterOption);
    setshowkm(formik.values.range);
    setshowvenue(formik.values.venue);
    setOpenFilter(false);
  }
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: true, // Ensures validation only happens on blur or submit
    validateOnBlur: false,
    onSubmit,
  });

  const shouldDisableDate = (
    date: Dayjs,
    activeMonth: any,
    activeYear: any,
    startDay: any,
    endDay: any,
    visitDaysString: string
  ) => {
    // Convert visitDaysInformation to an array
    const allowedDays = visitDaysString?.split(", ").map((day) => day?.trim());
    const formattedDate = date.format("YYYY-MM-DD");

    if (allocationCriteria?.holidayDates?.includes(formattedDate)) {
      return true;
    }

    if (
      allocationCriteria?.businessHolidays?.some(
        (holiday: any) => holiday?.date === formattedDate
      )
    ) {
      return true;
    }
    // Get full day name (e.g., "Monday")
    const dayName = date?.format("dddd");


    // Disable if the day is NOT in the allowedDays array
    if (!allowedDays?.includes(dayName)) {
      return true;
    }

    // Disable dates outside the active month and year
    if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
      return true;
    }

    // Disable dates outside the given range
    if (date.date() < startDay || date.date() > endDay) {
      return true;
    }
    // Hide non-weekend days 
    if (allocationCriteria?.isNeedToHideNonWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (!weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }
    // Hide weekend days 
    if (allocationCriteria?.isNeedToHideWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }
    // 6. New Condition ➡️ Block same weekday as lastJobVisitedDate
    if (
      allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
      allocationCriteria?.lastJobVisitedDate
    ) {
      const lastVisitedDayName = dayjs(
        allocationCriteria.lastJobVisitedDate
      ).format("dddd"); // Get day name from last visited date
      if (dayName === lastVisitedDayName) {
        return true; // Block this date
      }
    }

    // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
    if (allocationCriteria?.minDaysGapBetweenJobs) {
      const gapRequired = allocationCriteria.minDaysGapBetweenJobs;

      if (
        allocationCriteria?.currentMonthVisitedDates &&
        allocationCriteria.currentMonthVisitedDates.length > 0
      ) {
        const visitedDates = allocationCriteria.currentMonthVisitedDates;

        for (let visit of visitedDates) {
          const visitDate = dayjs(visit);

          const startBlockedDate = visitDate.subtract(gapRequired, "day");
          const endBlockedDate = visitDate.add(gapRequired, "day");

          if (
            (date.isAfter(startBlockedDate, "day") &&
              date.isBefore(endBlockedDate, "day")) ||
            date.isSame(startBlockedDate, "day") ||
            date.isSame(endBlockedDate, "day") ||
            date.isSame(visitDate, "day") // include exact visit date
          ) {
            return true;
          }
        }
      }

      // 🔹 2. Else fallback to single date
      else if (allocationCriteria?.lastJobVisitedDate) {
        const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);

        const startBlockedDate = lastVisitDate.subtract(gapRequired, "day");
        const endBlockedDate = lastVisitDate.add(gapRequired, "day");

        if (
          (date.isAfter(startBlockedDate, "day") &&
            date.isBefore(endBlockedDate, "day")) ||
          date.isSame(startBlockedDate, "day") ||
          date.isSame(endBlockedDate, "day") ||
          date.isSame(lastVisitDate, "day")
        ) {
          return true;
        }
      }
    }

    // 🔹 Block dates between venueOpenMinus7Days and venueClosePlus3Days
    if (
      allocationCriteria?.venueOpenMinus7Days &&
      allocationCriteria?.venueClosePlus3Days
    ) {
      const date1 = dayjs(allocationCriteria.venueOpenMinus7Days);
      const date2 = dayjs(allocationCriteria.venueClosePlus3Days);

      if (!date1.isValid() || !date2.isValid()) {
        console.log("Invalid date");
        return false;
      }

      const start = date1.isBefore(date2) ? date1 : date2;
      const end = date1.isBefore(date2) ? date2 : date1;

      if (
        (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
        date.isSame(start, "day") ||
        date.isSame(end, "day")
      ) {
        return true;
      }
    }
  };



  useEffect(() => {
    const loadAutocomplete = () => {
      // console.log("Loading autocomplete...");
      // console.log("Google available:", !!window.google);
      // console.log("Input ref:", inputRef.current);

      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error("Google Maps Places API is not loaded.");
        return;
      }

      if (!inputRef.current) {
        console.error("Input reference is null.");
        return;
      }

      try {
        // Clear any existing autocomplete
        if (autocompleteRef.current) {
          window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
        }

        autocompleteRef.current = new window.google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["geocode"],
            componentRestrictions: { country: "AU" },
          }
        );

        // console.log("Autocomplete initialized:", autocompleteRef.current);

        autocompleteRef.current.addListener("place_changed", () => {
          const place = autocompleteRef.current.getPlace();
          // console.log("Place selected:", place);

          if (!place || !place.formatted_address) {
            toast.info("No address found.");
            return;
          }

          let postalCode = "";
          if (place.address_components) {
            const postalComponent = place.address_components.find((component) =>
              component.types.includes("postal_code")
            );
            postalCode = postalComponent ? postalComponent.long_name : "";
          }

          if (place.geometry?.location) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            formik.setFieldValue("latitude", lat);
            formik.setFieldValue("longitude", lng);
            formik.setFieldValue("location", place.formatted_address);

            const newCenter = { lat, lng };
            setMapCenter(newCenter);
            setMarkerPosition(newCenter);
            setLocation({ latitude: lat, longitude: lng });
          }

          setPostalCode(postalCode);
        });
      } catch (error) {
        console.error("Error initializing autocomplete:", error);
      }
    };

    // Add a small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      loadAutocomplete();
    }, 100);

    return () => {
      clearTimeout(timer);
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [formik.values.filterOption, alignment]);

  useEffect(() => {
    const fetchVenues = async () => {
      setVenueList([])
      try {
        const data = `?offset=0&venueStatus=Active&limit=500${selectedentitytype ? `&entityTypeId=${selectedentitytype}` : ''}${selectedstate ? `&state=${selectedstate}` : ''}${searchvenue.length > 0 ? `&searchVenue=${searchvenue}` : ''}${selectedClient !== 'all' ? `&clientGroupName=${selectedClient}` : ''}`;
        const response = await SearchName(data);
        if (response.status) {
          const venues = response.data.map((venue: any) => ({
            venueId: venue.venueId,
            venueName: venue.venueName,
          }));
          setVenueList(venues);
          setFilteredVenues(venues);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
    selectedClient && fetchVenues();
  }, [selectedClient, selectedentitytype, selectedstate, searchvenue]);

  // Filter venues based on user input
  useEffect(() => {
    if (!formik.values.venue.trim()) {
      setFilteredVenues(venueList);
      return;
    }

    const queryLower = formik.values.venue.toLowerCase();
    const filtered = venueList.filter((venue) =>
      venue.venueName.toLowerCase().includes(queryLower)
    );
    // Sort logic
    filtered.sort((a, b) => {
      const aLower = a.venueName.toLowerCase();
      const bLower = b.venueName.toLowerCase();

      if (aLower === queryLower) return -1;
      if (bLower === queryLower) return 1;

      const aStartsWith = aLower.startsWith(queryLower);
      const bStartsWith = bLower.startsWith(queryLower);
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;

      return aLower.indexOf(queryLower) - bLower.indexOf(queryLower);
    });

    setFilteredVenues(filtered);
  }, [formik.values.venue, venueList, selectedentitytype, selectedstate]);

  useEffect(() => {
    formik.values.location = "";

    if (formik.values.venue.length > 0 || selectedstate) {
      formik.values.filterOption = "";
      formik.values.range = "";
      formik.values.location = "";
    }

    else if (selectedentitytype || formik.values.venue.length === 0) {
      formik.values.filterOption = "myHome";
      formik.values.range = "50";
      formik.values.location = "";
    }

    else {
      formik.values.filterOption = "myHome";
      formik.values.range = "50";
    }
  }, [formik.values.venue, selectedstate, selectedentitytype, selectedClient]);


  useEffect(() => {
    if (parseInt(formik.values.range) > 0) {
      formik.setFieldValue('venueId', null)
      // setselectedClient(' ')
      // setselectedentitytype(null)
      setsearchvenue('')
      // setselectedestate(null)
    }
  }, [formik.values.range])

  // -----------------------------------------------------get location -----------------------------------------------
  // useEffect(() => {

  //     const getLocation = () => {
  //         if (navigator.geolocation) {
  //             navigator.geolocation.getCurrentPosition(
  //                 (position) => {
  //                     setLocation({
  //                         latitude: position.coords.latitude,
  //                         longitude: position.coords.longitude,
  //                     });
  //                 },
  //                 (error) => {
  //                     alert(error.message);
  //                     formik.setFieldValue("filterOption", "myHome");
  //                 }
  //             );
  //         } else {
  //             // console.log("Geolocation is not supported by this browser.");
  //         }
  //     }
  //     { formik.values.filterOption === 'nearMe' && getLocation()}
  // }, [formik.values.filterOption])
  // console.log("Formik /", formik.values.filterOption);

  const handleOpenQuiz = async (clientEntityId: string, venueId: String) => {
    setSelectedOptions([])
    const data = `?clientEntityId=${clientEntityId}&venueId=${venueId}`
    const response = await ApiGetQuiz(data)
    // setQuizList(response.data)
    setQuizType(response?.quizType)
    setQuizList(shuffleArray(response.data))
    // allocationCriteria && allocationCriteria?.isQuizRequired ? setOpenBriefDialog(true) : toast.success("Quiz is not required")
    if (allocationCriteria && allocationCriteria?.isQuizRequired) {
      if (allocationCriteria?.isNewBriefSetup) {
        setOpenNewBriefDialog(true)
        setOpenQuiz(false)
      }
      else {
        setOpenQuiz(true)
        setOpenNewBriefDialog(false)
      }
    }
    else {
      if (allocationCriteria?.isNewBriefSetup) {
        setOpenBriefDialog(false)
        setOpenNewBriefDialog(true)
      }
      else {
        setOpenBriefDialog(true)
        setOpenNewBriefDialog(false)
      }
    }
  }

  useEffect(() => {
    setSelectedOptions([])
    const newOptions = QuizList.map((item) => ({
      QuestionId: item.quiz_question_id,
      SelectedAnswer: null,
      answerIds: item.answerIds || ""
    }));

    setSelectedOptions(prevOptions => [...prevOptions, ...newOptions]);
  }, [QuizList])

  useEffect(() => {
    const getLocation = () => {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          if (permissionStatus.state === "granted") {
            // User already allowed location
            navigator.geolocation.getCurrentPosition((position) => {
              setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              });
            });
          } else if (permissionStatus.state === "prompt") {
            // User hasn't decided yet, ask for permission
            navigator.geolocation.getCurrentPosition(
              (position) => {
                setLocation({
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                });
              },
              (error) => {
                toast.error(error.message);
                formik.setFieldValue("filterOption", "myHome");
              }
            );
          } else if (permissionStatus.state === "denied") {
            // User denied location before, suggest enabling it
            toast.error(
              "Location access is blocked. Please enable it in your browser settings."
            );
            formik.setFieldValue("filterOption", "myHome");
          }
        });
    };

    if (formik.values.filterOption !== '') {
      setselectedestate('')
      formik.values.venue = ''
      formik.values.venueId = 0
    }
    if (formik.values.filterOption === "nearMe") {
      getLocation();
    }
  }, [formik.values.filterOption]);

  const handlePrevMonth = () => {
    const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth));
  };

  const handleNextMonth = () => {
    const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
    dispatch(setSelectedMonth(newMonth))
  };



  const getallocation = async (currentOffset = 0, append = false, needtoset = false) => {
    try {
      setIsLoadingMore(true);

      applyfilters.jobMonth = selectedmonth.month() + 1;
      Object.assign(applyfilters, {
        isUseForRunningAllocation: true,
        limit: LIMIT,
        offset: currentOffset,
      })
      applyfilters.jobYear = selectedmonth.year();
      applyfilters.userId = userData.userId;
      if (formik.values.filterOption == "myHome" && !selectedstate) {
        Object.assign(applyfilters, {
          nearByHome: true,
          // nearBy: true,
        });
      }
      if (!selectedstate && (formik.values.filterOption == "nearMe" || formik.values.filterOption == "manual")) {
        Object.assign(applyfilters, {
          // nearByHome: true,
          nearBy: true,
        });
      }

      if (selectedentitytype) {
        applyfilters.entityTypeId = selectedentitytype
      }

      if (selectedstate) {
        applyfilters.state = selectedstate
      }
      if (selectedClient !== 'all') {
        applyfilters.allocationClientGroup = selectedClient
      }

      if (formik.values.venue.length === 0 && !selectedstate) {
        applyfilters.kilometerRange = formik.values.range;
      }
      else if (formik.values.venue.length > 0) {
        applyfilters.venueId = formik.values.venueId;
      }

      if (
        formik.values.filterOption === "nearMe" ||
        formik.values.filterOption === "manual"
      ) {
        Object.assign(applyfilters, {
          latitude: location?.latitude,
          longitude: location?.longitude,
        });
      }
      const response = await fetchAllocations(applyfilters)
      // alignment === 'individual' && setAllocation({
      //   ...response,
      //   data: response.data?.filter((card: any) => card.allocationClientGroup !== "TRANSPORT")
      // });
      // console.log("totalAllocation:", allocations);
      // console.log("send Options:", applyfilters);
      // console.log("send latitude:", location?.latitude);
      // console.log("send longitude:", location?.longitude);
      // console.log("selectedId:", selectedId);
      // console.log("SendData", applyfilters);
      // filterOptionref.current?.innerText=
      let filteredData = response.data || [];
      if (alignment === 'individual') {
        filteredData = filteredData.filter((card: any) => card.allocationClientGroup !== "TRANSPORT");
      }

      // Append or replace data
      if (append && currentOffset > 0) {
        setAllocation(prev => ({
          ...response,
          data: [...(prev?.data || []), ...filteredData]
        }));
      } else {
        if (needtoset) {
          settotalmapallocations((prev) => [
            ...prev,
            ...filteredData
          ]);
        }
        setAllocation({
          ...response,
          data: filteredData
        });
        const data2 = {
          allocationId: response.data[0]?.allocationId,
          clientEntityId: response.data[0]?.venueId.clientEntityId?.clientEntityId,
          venueId: response.data[0]?.venueId.venueId,
          jobMonth: response.data[0]?.jobMonth,
          jobYear: response.data[0]?.jobYear,
          userId: userData?.userId,
        }
        fetchAllocationCriteria(data2);
        currentOffsetRef.current = 0;
      }
      if (filteredData.length > 0) {
        currentOffsetRef.current = currentOffset + filteredData.length;
      }
      // Check if there's more data
      setHasMore(filteredData.length >= LIMIT);
      setshowfilter(formik.values.filterOption);
      setshowkm(formik.values.range);
      setshowvenue(formik.values.venue);
      setOpenFilter(false);
    } catch (error) {
      console.error("Error fetching applied allocations:", error);
    } finally {
      setIsLoadingMore(false)
    }
  };


  useEffect(() => {
    setshowfilter(formik.values.filterOption);
    setshowkm(formik.values.range);
    setshowvenue(formik.values.venue);
  }, [totalallocation])

  const getmapallocations = async () => {
    formik.setFieldValue("location", formik.values.location)
    formik.setFieldValue("filterOption", "manual");
    // formik.setFieldValue("range", "manual");
    settotalmapallocations([])
    const data = {
      jobMonth: selectedmonth.month() + 1,
      jobYear: selectedmonth.year(),
      userId: userData.userId,
      kilometerRange: formik.values.range,
      latitude: location?.latitude,
      longitude: location?.longitude,
      nearBy: true,
      limit: 100,
      isUseForRunningAllocation: true
    }
    const response = await fetchAllocations(data)

    settotalmapallocations(
      response.data?.filter((card: any) => card.allocationClientGroup != "TRANSPORT"))

    setAllocation({
      ...response,
      data: response.data?.filter((card: any) => card.allocationClientGroup != "TRANSPORT")
    });
    const respons2 = await fetchbundleallocation(data)
    // formik.setFieldValue("filterOption", "manual");
  }

  const fetchAllocationCriteria = async (item: any) => {
    const data = `?allocationId=${item.allocationId}&clientEntityId=${item.clientEntityId}&userId=${item.userId}`;
    try {
      const response = item?.allocationId && item.clientEntityId && item?.userId && await ApiGetAllocationCriteriaDetails(data);
      setAllocationCriteria(response.data);
    } catch (error) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      console.log(message)
    }
  };
  useEffect(() => {
    if (alignment === 'map') getmapallocations()
  }, [location])


  // console.log("Allocation Criteria--->", allocationCriteria)
  useEffect(() => {
    if (totalallocation?.data?.length > 0) {
      selectcard(0)
    }
  }, [totalallocation])
  // useEffect(() => {
  //   const SetTimeArray = async() => {
  //     if (totalallocation?.data?.length > 0) {
  //       setSelectedId(window.innerWidth <= 576 ? null : 0);

  //       // if (isFirstLoadRef.current && alignment === 'individual') {
  //       //   const data = {
  //       //     allocationId: totalallocation && totalallocation.data[0]?.allocationId,
  //       //     clientEntityId: totalallocation && totalallocation.data[0]?.venueId.clientEntityId?.clientEntityId,
  //       //     userId: totalallocation && userData?.userId,
  //       //   }
  //       //  await fetchAllocationCriteria(data);
  //       //   isFirstLoadRef.current = false;
  //       // }
  //       // dispatch(
  //       //   findData(
  //       //     totalallocation.data[0].visitTimeInformation.split(",").map(Number)
  //       //   )
  //       // );
  //       const locationType = totalallocation?.data?.[0]?.venueId?.locationType;
  //       const visitTimeArray =
  //         locationType === "region"
  //           ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
  //           : totalallocation?.data?.[0]?.visitTimeInformation?.split(",").map(Number);
  //       console.log("Visit Time Array", visitTimeArray)
  //       console.log("Criiteria Visit Time", allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number))
  //       console.log("Allocation Visit Time", totalallocation?.data?.[0]?.visitTimeInformation?.split(",").map(Number))

  //       dispatch(findData(visitTimeArray));


  //     }
  //   }
  //   setTimeout(() => {
  //     SetTimeArray()
  //   }, 300);
  // }, [totalallocation]);
  // console.log("FIlter Valuee---->", filtervalue)



  const fetchData = async () => {
    try {
      const response = await getVisitTimes();
      // console.log("Get Visited Time", response.data);

      dispatch(setData(response.data));
    } catch (error) {
      console.error("Error fetching visit times:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const selectcard = async (index: number) => {
    setSelectedId(index);
    const item = {
      allocationId: totalallocation && totalallocation.data[index || 0]?.allocationId,
      clientEntityId: totalallocation && totalallocation.data[index || 0]?.venueId.clientEntityId?.clientEntityId,
      venueId: totalallocation && totalallocation.data[index || 0]?.venueId.venueId,
      jobMonth: totalallocation && totalallocation.data[index || 0]?.jobMonth,
      jobYear: totalallocation && totalallocation.data[index || 0]?.jobYear,
      userId: totalallocation && userData?.userId,
    }
    // console.log("filteredTime", filtervalue);
    const data = `?allocationId=${item.allocationId}&clientEntityId=${item.clientEntityId}&userId=${item.userId}`;
    try {
      const response = item?.allocationId && item?.clientEntityId && item?.userId && await ApiGetAllocationCriteriaDetails(data);
      setAllocationCriteria(response.data);
      const locationType = totalallocation?.data?.[index || 0]?.venueId?.locationType;

      const visitTimeArray =
        // locationType === "region"
        //   ? response?.data?.regionVisitTimeInformation?.split(",").map(Number)
        //   : 
        totalallocation?.data?.[index || 0]?.visitTimeInformation?.split(",").map(Number);
      dispatch(findData(visitTimeArray));

    } catch (error: any) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      console.log(message)
    }
    // await fetchAllocationCriteria(data);
    // dispatch(
    //   findData(
    //     totalallocation?.data[index || 0].visitTimeInformation
    //       ?.split(",")
    //       ?.map(Number)
    //   )
    // );
    // const locationType = totalallocation?.data?.[index || 0]?.venueId?.locationType;

    //   console.log("ALlocation Criteria--->", allocationCriteria)
    //   const visitTimeArray =
    //     locationType === "region"
    //       ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
    //       : totalallocation?.data?.[index || 0]?.visitTimeInformation?.split(",").map(Number);
    //   console.log("Allocation Criteria Time ---->", response?.data?.regionVisitTimeInformation?.split(",").map(Number))
    //   console.log("Allocation  Time ---->", totalallocation?.data?.[index || 0]?.visitTimeInformation?.split(",").map(Number))
    //   console.log("Visit Time ---->", visitTimeArray)
    //   dispatch(findData(visitTimeArray));

  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setSelectedId(selectedId ? selectedId : 0);
      } else {
        setSelectedId(selectedId ? selectedId : 0);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  const handleBriefDialogOpen = () => {
    setOpenBriefDialog(true);
  };

  const handleBriefDialogClose = () => {
    setOpenBriefDialog(false);
  };

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const VisitDateResetter = ({ selectedmonth, selectedId, totalallocation }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
      if (
        selectedmonth &&
        totalallocation?.data[selectedId]?.jobMonth &&
        selectedmonth.month() + 1 !== totalallocation.data[selectedId].jobMonth
      ) {
        setFieldValue("selectedVisitDate", "");
      }
    }, [selectedmonth, selectedId]);

    return null; // This component only runs the effect
  };


  useEffect(() => {
    const getshoptype = async () => {
      try {
        const data = selectedClient !== 'all' ? `?clientGroupName=${selectedClient}` : ''
        const res = await ApiGetEntityType(data)
        if (res.data) {
          setentitytypelist(res.data)
        }
      } catch (error) {
      }
    }
    if (selectedClient) { getshoptype() }
  }, [selectedClient])


  useEffect(() => {
    const getstatelist = async () => {
      try {
        const data = `${selectedClient !== 'all' ? `?clientGroupName=${selectedClient}` : ''}`
        const res = await ApiGetStates(data)
        setstatelist(res.data)

      } catch (error) {
      }
    }
    selectedClient && getstatelist()
  }, [selectedClient])

  // console.log("Selected State", selectedstate)


  const calculateMapCenter = (data) => {
    if (!data || data.length === 0) return { lat: 0, lng: 0 };

    const total = data.reduce(
      (acc, item) => {
        const lat = parseFloat(item?.venueId?.lat);
        const lng = parseFloat(item?.venueId?.long);
        return {
          lat: acc.lat + (isNaN(lat) ? 0 : lat),
          lng: acc.lng + (isNaN(lng) ? 0 : lng),
        };
      },
      { lat: 0, lng: 0 }
    );

    const count = data.length;
    return {
      lat: total.lat / count,
      lng: total.lng / count,
    };
  };

  useEffect(() => {
    if (totalallocation?.data?.length > 0) {
      const center = calculateMapCenter(totalallocation.data);
      setMapCenter(center);
    }
  }, [totalallocation]);




  // // Fit map to bounds when data changes
  // useEffect(() => {
  //   if (mapLoaded && totalmapallocations?.data?.length > 0 && mapRef.current) {
  //     const bounds = new window.google.maps.LatLngBounds();

  //     totalallocation.data.forEach((item) => {
  //       const lat = parseFloat(item?.venueId?.lat);
  //       const lng = parseFloat(item?.venueId?.long);
  //       if (!isNaN(lat) && !isNaN(lng)) {
  //         bounds.extend({ lat, lng });
  //       }
  //     });

  //     if (!bounds.isEmpty()) {
  //       mapRef.current.fitBounds(bounds);
  //     }
  //   }
  // }, [mapLoaded, totalallocation, alignment]);

  useEffect(() => {
    if (selectedId !== null && itemRefs.current[selectedId]) {
      itemRefs.current[selectedId]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest", // or "center" / "start"
      });
    }
  }, [selectedId]);

  const allocationLogo = (allocationclientGroupName) => {

    switch (allocationclientGroupName) {
      case "BLOOMS":
        return BLOOMS
        break;
      case "ALDI":
        return ALDI
        break;
      case "MM":
        return MM
        break;

      default:
        return MM
        break;
    }
  }

  // Handle scroll event
  const handleScroll = (e) => {
    const element = e.target;
    const bottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 100;

    if (bottom && hasMore && !isLoadingMore && alignment !== 'bulk') {
      getallocation(currentOffsetRef.current, true);
    }
  };

  // Reset pagination when filters change
  // const handleResetPagination = () =>{
  //   currentOffsetRef.current = 0;
  //   isFirstLoadRef.current = true
  //   setHasMore(true);
  //   setIsLoadingMore(false);
  // }

  useEffect(() => {
    if (!selectedmonth) return;

    // if (hasFetchedRef.current) return;
    // console.log("From Fist Block---->1")
    // hasFetchedRef.current = true;
    currentOffsetRef.current = 0;
    isFirstLoadRef.current = true
    setHasMore(true);
    setIsLoadingMore(false);
    alignment !== 'bulk' && alignment !== "map" && selectedmonth && getallocation(0, false);
    // }, [selectedmonth, formik.values.filterOption, selectedentitytype, selectedstate, selectedClient, formik.values.venue]);
  }, [selectedmonth]);

  // useEffect(() => {
  //   if (!mapRef.current) return;
  //   if (!totalmapallocations || totalmapallocations.length === 0) {
  //     mapRef.current.setCenter({ lat: parseInt(userData?.latitude), lng: parseInt(userData?.longitude) }); // Sydney default
  //     mapRef.current.setZoom(10);
  //     return;
  //   }
  //   const bounds = new window.google.maps.LatLngBounds();

  //   totalmapallocations.forEach((item) => {
  //     const lat = parseFloat(location?.latitude);
  //     const lng = parseFloat(item?.venueId?.long);

  //     if (!isNaN(lat) && !isNaN(lng)) {
  //       bounds.extend({ lat, lng });
  //     }
  //   });
  //   mapRef.current.setZoom(1);   // Reset zoom so fitBounds works again
  //   mapRef.current.fitBounds(bounds); // Auto center + zoom
  // }, [totalmapallocations, mapLoaded]);
  useEffect(() => {
    if (!mapRef.current || !mapLoaded) return;

    // 1️⃣ Prefer searched location
    if (location?.latitude && location?.longitude) {
      const lat = location?.latitude;
      const lng = location?.longitude;

      if (!isNaN(lat) && !isNaN(lng)) {
        mapRef.current.setCenter({ lat, lng });
        mapRef.current.setZoom(14);
        return;
      }
    }

    // 2️⃣ Fallback to user location
    const userLat = parseFloat(userData?.latitude);
    const userLng = parseFloat(userData?.longitude);

    if (!isNaN(userLat) && !isNaN(userLng)) {
      mapRef.current.setCenter({ lat: userLat, lng: userLng });
      mapRef.current.setZoom(15);
    }
  }, [location, userData, mapLoaded]);


  const getBrief = async (venueId: string, clientEntity: string) => {
    try {
      const data = `?venueId=${venueId}&clientEntityId=${clientEntity}`
      const res = await ApiGetNewBrief(data)
      if (res?.status || res?.success) {
        setNewBrief(res)
        return res;
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  const handleReadBrief = async () => {
    try {
      const res = await getBrief(
        totalallocation?.data[selectedId]?.venueId?.venueId,
        totalallocation?.data[selectedId]?.clientEntityId?.clientEntityId)
      setNewBrief(res)

      if (allocationCriteria?.isNewBriefSetup) {
        setOpenNewBriefReadDialog(true)
      }
      else {
        handleDialogOpen();
      }
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <Box width="100%" height="100%" overflow={'auto'} maxHeight={'calc(100vh - 70px)'}>
      <Box
        className="justify-content-between mytask align-items-end flex-wrap flex-md-row mb-0"
        display={{ xs: selectedId !== null ? "none" : "flex", sm: "flex" }}
      >
        <Box className='col-lg-4 col-12' bgcolor={{ xs: "#ADB7922A", lg: 'transparent' }}>
          <Box className="col-12 pt-3 d-lg-none">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box
                display="flex"
                alignItems="center"
                className="col-12  d-flex align-items-center justify-content-between"
              >
                {/* Previous Month Button */}
                <IconButton
                  onClick={handlePrevMonth}
                  className="d-none d-md-block"
                >
                  <KeyboardArrowLeft />
                </IconButton>

                {/* Month & Year Selector */}
                <DatePicker
                  className="w-100"
                  views={["month", "year"]}
                  value={selectedmonth}
                  onChange={(date) => { date && dispatch(setSelectedMonth(date.toISOString())); }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}

                  sx={{
                    // "@media (max-width: 600px)": {
                    //   input: { display: "none" }, // Hide input on extra-small screens
                    // },

                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      maxWidth: "70%",
                    },
                    "& .MuiOutlinedInput-input": {
                      maxWidth: "90%",
                      fontSize: "18px !important",
                    },
                    "& .MuiIconButton-root": {
                      margin: "0px",
                      padding: "0px",
                      color: "#7C9FB2",
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: { xs: "32px", md: "20px" },
                    },

                    "& .MuiOutlinedInput-root": {
                      margin: "0px",
                      paddingLeft: "0px",
                      // maxWidth:'190px !important'
                    },
                  }}
                />

                <IconButton
                  onClick={handleNextMonth}
                  className="d-none d-md-block"
                >
                  <KeyboardArrowRight />
                </IconButton>
              </Box>
            </LocalizationProvider>
          </Box>
          <Box p={{ xs: 0, lg: 3 }} className="phone-menue col-12  pb-lg-0 mb-0">
            <ToggleButtonGroup
              className="row w-100 d-flex justify-content-center m-0 px-0 mx-auto"
              exclusive
              value={alignment}
              onChange={handleChange}
            >
              <ToggleButton className="py-2 col-4" value="individual">
                Individual
              </ToggleButton>
              <ToggleButton className="py-2 col-4" value="bulk">
                Bundle
              </ToggleButton>
              <ToggleButton className="py-2 col-4" value="map">
                Map
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
        <Box justifyContent={{ xs: "center", lg: "space-between" }} className="col-12 d-flex flex-wrap-reverse align-items-center mx-md-0 col-lg-8 p-0 p-lg-3 pt-0 pb-lg-0 mb-0">
          {(alignment === 'individual' || alignment === 'bulk') && (
            <Box className="p-2 p-lg-3  pb-lg-0 mb-0">
              <Box
                className="d-flex bg-second mx-auto text-center justify-content-between py-1  ps-3 pe-1 align-items-center"
                width="fit-content"
                borderRadius="50px"
              >
                <Typography className="text-light text-center">
                  {showfilter
                    ? showfilter === "nearMe"
                      ? "Near Me"
                      : showfilter === "myHome"
                        ? "My Home"
                        : PostalCode
                    : showvenue ? showvenue : selectedClient}
                </Typography>

                <Divider orientation="vertical" className="mx-3 divider" />
                {showkm && showfilter && (
                  <>
                    <Typography className="text-light text-center">
                      {showkm}km
                    </Typography>
                    <Divider orientation="vertical" className="ms-3 me-1 divider" />
                  </>
                )}
                <IconButton
                  className="text-light"
                  onClick={() => setOpenFilter(true)}
                >
                  <Box component="img" width="60%" src={filter} alt="filter"></Box>
                </IconButton>
              </Box>
            </Box>)}
          <Box gap={2} className="d-block d-none d-lg-flex mt-3 mt-md-0 ms-auto justify-content-end  align-items-center">
            <Box className="col-12">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  display="flex"
                  alignItems="center"
                  className="col-11 d-flex align-items-center justify-content-end"
                >
                  {/* Previous Month Button */}
                  <IconButton
                    onClick={handlePrevMonth}
                    className="d-none d-md-block"
                  >
                    <KeyboardArrowLeft />
                  </IconButton>

                  {/* Month & Year Selector */}
                  <DatePicker
                    className=""
                    views={["month", 'year']}
                    value={selectedmonth}
                    onChange={(date) => { date && dispatch(setSelectedMonth(date.toISOString())); }}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                    open={openPicker}
                    onOpen={() => setOpenPicker(true)}
                    onClose={() => setOpenPicker(false)}

                    sx={{
                      // "@media (max-width: 600px)": {
                      //   input: { display: "none" }, // Hide input on extra-small screens
                      // },

                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        maxWidth: "70%",
                      },
                      "& .MuiOutlinedInput-input": {
                        maxWidth: "90%",
                      },
                      "& .MuiIconButton-root": {
                        margin: "0px",
                        padding: "0px",
                        color: "#7C9FB2",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: { xs: "32px", md: "20px" },
                      },

                      "& .MuiOutlinedInput-root": {
                        margin: "0px",
                        paddingLeft: "0px",
                        // maxWidth:'190px !important'
                      },
                    }}
                  />

                  <IconButton
                    onClick={handleNextMonth}
                    className="d-none d-md-block"
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                </Box>
              </LocalizationProvider>
            </Box>
          </Box>
        </Box>
      </Box>

      {(alignment === 'individual' && (totalallocation?.data?.length) > 0) && (
        <Box
          className="d-flex flex-column flex-lg-row"

          minHeight={{ md: "calc(100vh - 133px)" }}
          height="100%"
          overflow={'auto'}
          maxHeight={{ xs: "calc(100vh - 100px)", md: 'calc(100vh - 160px)' }}
        >
          {alignment === 'individual' && (
            <Box
              className="col-lg-4 col-12 p-4 pt-0 pe-lg-0  p-lg-3"
              display={{
                xs: selectedId !== null ? "none" : "block",
                sm: "block",
              }}
            >
              {/* ------------------------------------------------------------------------------------- Tasks ------------------------------------------------------------- */}
              <Box
                className="mt-4 h-100"
                height='100%'
                maxHeight="calc(100vh - 230px)"
                overflow="auto"
                ref={scrollContainerRef}
                onScroll={handleScroll}

              >
                {totalallocation?.data?.map((card: any, index: number) => (
                  <Box
                    ref={(el: any) => (itemRefs.current[index] = el)}
                    className={clsx("task mb-3", {
                      "bg-alternate": selectedId === index,
                    })}
                    border={
                      selectedId === index
                        ? ""
                        : "1px solid #ccc"
                    }
                    key={index}
                    onClick={() => {
                      selectcard(index);
                      setisConfirmApply(false)
                    }}
                  >
                    <Box className="d-flex gap-2 align-items-center">
                      {/* <Avatar sx={{ height: '42px', width: '42px' }}>{totalallocation?.data[index].venueId.logoUrl}</Avatar> */}
                      <Avatar
                        src={card?.venueId?.logoUrl}
                        sx={{
                          height: "40px",
                          width: "42px",
                          img: {
                            objectFit: "contain", // ensures the full image fits inside
                          },
                        }}
                      >
                        {(!card?.venueId?.logoUrl && card?.venueId?.venueName?.[0]?.toUpperCase()) || "N"}
                      </Avatar>

                      <Box>
                        <Box className='d-flex align-items-start' gap={1}>
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            className='m-0 p-0'
                          >
                            {card.venueId?.venueName} {card?.differentiateKey ? `(${card?.differentiateKey})` : ''}
                          </Typography>
                          <Avatar
                            src={allocationLogo(card?.allocationClientGroup)}
                            sx={{
                              backgroundColor: selectedId === index ? 'white' : 'transparent',
                              height: "24px",
                              width: "24px",
                              img: {
                                objectFit: "contain", // ensures the full image fits inside
                              },
                            }}
                          />
                        </Box>
                        <Typography
                          variant="caption"
                          className='task-caption'
                        >
                          {card?.allocationPriceDisplay !== "" ? card?.allocationPriceDisplay : 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="body2"
                        className='text-end text-dark'
                      >
                        {card?.distanceInKm}
                        {card?.distanceInKm ? "km" : ""}
                      </Typography>
                      <Box className="d-flex" gap={1}>
                        <Typography
                          variant="caption"
                          className='px-3 py-1 bg-second text-light'
                          borderRadius="8px"

                        >
                          {card.venueId?.clientEntityId?.entityTypeId?.entityTypeName}
                        </Typography>
                        {card.venueId?.regionId?.regionName && card?.allocationClientGroup == "ALDI" && (
                          <Typography
                            variant="caption"
                            className='px-3 py-1 bg-second text-light'
                            borderRadius="8px"

                          >
                            {card.venueId?.regionId?.regionName}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))}

                {isLoadingMore && (
                  <Box className="text-center py-3">
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Box>
            </Box>
          )}

          <Box className="col-lg-8 col-12 p-3" overflow='auto' maxHeight={{ xs: "100vh", md: "calc(100vh - 70px)" }}>
            {selectedId !== null && totalallocation?.data[selectedId] && (
              <>
                <Box
                  className="d-flex h-100 flex-md-row flex-column"
                  border={{ xs: "none", sm: "1px solid #a3a3a3" }}
                  borderRadius="10px"
                // height={'fit-content'}
                >
                  <IconButton
                    className="w-100 justify-content-start d-flex d-md-none"
                    onClick={() => {
                      setSelectedId(null);
                    }}
                  >
                    <WestOutlined fontSize="medium" />
                  </IconButton>
                  <Box sx={{ borderRight: '1px solid #a3a3a3' }} className="col-md-6 col-xl-7 col-12 p-3">
                    <Box className="d-flex gap-3">
                      <Box className="d-flex gap-2">
                        {/* <Avatar sx={{ height: '42px', width: '42px' }}>{totalallocation?.data[selectedId].venueId.logoUrl}</Avatar> */}
                        <Avatar
                          src={
                            totalallocation?.data[selectedId]?.venueId?.logoUrl
                          }
                          sx={{
                            height: "40px",
                            width: "42px",
                            img: {
                              objectFit: "contain", // ensures the full image fits inside
                            },
                          }}
                        >
                          {(!totalallocation?.data[selectedId]?.venueId?.logoUrl && totalallocation?.data[selectedId]?.venueId?.venueName?.[0]?.toUpperCase()) || "N"}
                        </Avatar>

                        <Box>
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            className="m-0 p-0"
                          >
                            {
                              totalallocation.data[selectedId].venueId
                                ?.venueName
                            }{totalallocation.data[selectedId]?.differentiateKey ? `(${totalallocation.data[selectedId]?.differentiateKey})` : ''}
                          </Typography>

                          <Box className='d-flex align-items-start gap-2'>
                            <Typography
                              variant="caption"
                              className="px-3 py-1 text-light bg-second"
                              borderRadius="8px"
                            >
                              {
                                totalallocation.data[selectedId].venueId
                                  ?.clientEntityId?.entityTypeId?.entityTypeName
                              }
                            </Typography>
                            {totalallocation.data[selectedId].venueId?.regionId?.regionName && totalallocation.data[selectedId]?.allocationClientGroup == "ALDI" && (
                              <Typography
                                variant="caption"
                                className='px-3 py-1 bg-second text-light'
                                borderRadius="8px"

                              >
                                {totalallocation.data[selectedId].venueId?.regionId?.regionName}
                              </Typography>
                            )}
                            <Avatar
                              src={allocationLogo(totalallocation.data[selectedId]?.allocationClientGroup)}
                              sx={{
                                // backgroundColor: selectedId === index ? 'white' : 'transparent',
                                height: "24px",
                                width: "24px",
                                img: {
                                  objectFit: "contain", // ensures the full image fits inside
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>

                    </Box>
                    <Box className="my-2">
                      <Typography variant="caption" className="text-grey">
                        Address
                      </Typography>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {totalallocation.data[selectedId].venueId?.address} {totalallocation.data[selectedId].venueId?.city} {totalallocation.data[selectedId].venueId?.state} {totalallocation.data[selectedId].venueId?.postalCode}
                      </Typography>
                    </Box>
                    <Box className="my-2">
                      <Typography variant="subtitle2" className="text-grey">
                        PostCode
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {totalallocation.data[selectedId].venueId?.postalCode}
                      </Typography>
                    </Box>
                    {totalallocation?.data[selectedId]?.venueId?.clientEntityId?.entityTypeId?.entityTypeName != "Liquor ID" &&
                      (
                        <Box className="my-2">
                          <Typography variant="subtitle2" className="text-grey">
                            Trading Hours
                          </Typography>

                          <Typography variant="subtitle1" fontWeight="bold">
                            {totalallocation.data[selectedId].venueId?.tradingHours}
                          </Typography>
                        </Box>
                      )}
                    <Box className="my-2">
                      <Typography variant="subtitle2" className="text-grey">
                        Website
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        <a target="__blank" href={totalallocation.data[selectedId].venueId?.websiteURL}>{totalallocation.data[selectedId].venueId?.websiteURL}</a>
                      </Typography>
                    </Box>
                    <Box className="my-2">
                      <Typography variant="caption" className="text-grey">
                        Price
                      </Typography>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {
                          totalallocation.data[selectedId]?.allocationPriceDisplay !== "" ? totalallocation.data[selectedId]?.allocationPriceDisplay : "N/A"
                        }
                      </Typography>
                    </Box>
                    <Box className="my-2">
                      <Typography variant="caption" className="text-grey">
                        Special Comments
                      </Typography>
                      <Typography variant="subtitle2" fontWeight="bold">
                        {totalallocation.data[selectedId].specialComment}
                      </Typography>
                    </Box>
                    <Box className="my-2">
                      <Button
                        fullWidth
                        variant="outlined"
                        className="button-secondary-outlined  transform border-20 mt-3"
                        // onClick={()=>{allocationCriteria?.isNewBriefSetup ? setOpenNewBriefDialog(true):handleDialogOpen()}}
                        // (allocationCriteria?.isNewBriefSetup) ? setOpenNewBriefDialog(true) : handleBriefDialogOpen();
                        onClick={() => { handleReadBrief() }}
                      >
                        Read Brief
                      </Button>
                    </Box>
                  </Box>
                  {/* {window.innerWidth > 767 && ( */}
                  <Divider
                    orientation="vertical"
                    sx={{
                      display: { xs: "none", sm: "block" },
                      borderColor: "#a3a3a3",
                    }}
                  />
                  {/* )} */}
                  <Formik
                    className="w-100 col-md-6 col-xl-5"
                    key={selectedId}
                    enableReinitialize
                    initialValues={{
                      allocationId: null,
                      selectedVisitDate: "",
                      selectedVisitTime: "",
                      createdBy: userData.userId,
                    }}
                    validationSchema={Yup.object({
                      selectedVisitDate: Yup.string().required("Select a Date"),
                      selectedVisitTime: Yup.string().required("Select a Time"),
                    })}

                    onSubmit={async (values) => {
                      const formattedValues = {
                        ...values,
                        allocationId:
                          totalallocation.data[selectedId].allocationId,
                        selectedVisitDate: values.selectedVisitDate
                          ? dayjs(values.selectedVisitDate).format("YYYY-MM-DD")
                          : "",
                      };

                      if (IsQuizSubmitted) {
                        try {
                          const data = {
                            userId: userData?.userId,
                            type: quizType,
                            ...(quizType === "venue"
                              ? {
                                venueId: totalallocation?.data?.[selectedId]?.venueId?.venueId,
                              }
                              : {
                                clientEntityId:
                                  totalallocation?.data?.[selectedId]?.venueId?.clientEntityId?.clientEntityId,
                              }),
                            //  quizType == "venue" ? venueId:totalallocation?.data[selectedId]?.venueId?.venueId : clientEntityId: totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId
                          }
                          await ApiSubmitQuiz(data)
                          const response = await applyTasks(formattedValues);
                          toast.success('You have successfully applied. Hold tight to find out if you are successful.');
                          navigate("/dashboard/MyTasks");
                          setOpenQuiz(false)
                          setIsQuizSubmitted(false)
                          setOpenBriefDialog(false)
                          setOpenNewBriefDialog(false)
                          setisConfirmApply(false)

                        } catch (error: any) {
                          // const message =
                          //   error?.response?.data?.message || // API error message
                          //   error?.message ||                 // JS error message
                          //   String(error);
                          toast.error(error?.message)
                        } finally {
                        }
                      }
                      else {
                        if (allocationCriteria && allocationCriteria?.isQuizRequired) {
                          // const data = `?clientEntityId=${totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId}`
                          // const response = await ApiGetQuiz(data)
                          // setQuizList(response.data)
                          await handleOpenQuiz(totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId, totalallocation?.data[selectedId]?.venueId?.venueId)
                          // setOpenQuiz(true)
                          // allocationCriteria?.isNewBriefSetup ? setOpenBriefDialog(true) : setOpenNewBriefDialog(true)
                          // setSelectedOptions([])
                          // setQuizList(shuffleArray(response.data))
                        }
                        else {
                          try {
                            const response = await applyTasks(formattedValues);
                            toast.success("Submit")
                            setOpenBriefDialog(false)
                            setOpenNewBriefDialog(false)
                            formik.resetForm()
                            // toast.success('You have successfully applied. Hold tight to find out if you are successful.');
                            navigate("/dashboard/MyTasks");
                          } catch (error: any) {
                            const message =
                              error?.response?.data?.message || // API error message
                              error?.message ||                 // JS error message
                              String(error);
                            toast.error(error?.message)
                          } finally {
                          }
                        }
                      }
                    }}
                  >

                    {(formik) => {
                      const handleApplyTaskClick = async () => {
                         console.log('Allocation Criteria',allocationCriteria?.isNewBriefSetup)
                        // console.log('Allocation Criteria',newBrief?.data)
                        formik.setTouched({
                          selectedVisitDate: true,
                          selectedVisitTime: true,
                        });
                        if(!formik.values.selectedVisitDate || !formik.values.selectedVisitTime)
                        {
                          return
                        }
                        //
                        // toast.success("Task Applied SuccessFully")
                        // setOpenBriefDialog(false)
                        // setOpenQuiz(false)
                        // setQuizList([])
                        // setSelectedOptions([])

                        // const errors = await formik.validateForm();

                        // if (Object.keys(errors).length > 0) {
                        //   return;
                        // }

                        if (allocationCriteria?.isNewBriefSetup) {
                          if (
                            allocationCriteria?.isQuizRequired
                          ) {
                            // setOpenNewBriefDialog(true)
                            setOpenInfo(true)
                          }
                          else {
                            formik.handleSubmit()
                          }
                        }
                        else {
                          handleBriefDialogOpen();
                        }
                      };


                      return (
                        <Form className="w-100">
                          <VisitDateResetter
                            selectedmonth={selectedmonth}
                            selectedId={selectedId}
                            totalallocation={totalallocation}
                          />
                          <Box className=" w-100 d-flex flex-column col-12 p-3">
                            <Box className="flex-grow-1">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <StaticDatePicker
                                  key={selectedmonth.toString()}
                                  value={
                                    formik.values.selectedVisitDate
                                      ? dayjs(formik.values.selectedVisitDate)
                                      : null
                                  }
                                  onChange={(newValue) => {
                                    formik.setFieldValue(
                                      "selectedVisitDate",
                                      newValue
                                        ? newValue.format("YYYY-MM-DD")
                                        : ""
                                    );
                                    const data2 = {
                                      allocationId: totalallocation?.data[selectedId]?.allocationId,
                                      clientEntityId: totalallocation?.data[selectedId]?.venueId.clientEntityId?.clientEntityId,
                                      venueId: totalallocation?.data[selectedId]?.venueId.venueId,
                                      jobMonth: totalallocation?.data[selectedId]?.jobMonth,
                                      jobYear: totalallocation?.data[selectedId]?.jobYear,
                                      userId: userData?.userId,
                                    }
                                    newValue && allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && handleCallAnotherCriteria(data2, allocationCriteria?.isNeedToHideWeekend, allocationCriteria?.isNeedToHideNonWeekend)
                                  }}
                                  referenceDate={
                                    selectedmonth
                                      ? dayjs(selectedmonth, "YYYY-MM")
                                      : dayjs(`${totalallocation.data[selectedId].jobYear}-${String(totalallocation.data[selectedId].jobMonth).padStart(2, "0")}`, "YYYY-MM")

                                  }

                                  // minDate={dayjs(
                                  //   selectedmonth,
                                  //   "YYYY-MM"
                                  // ).startOf("month")}
                                  minDate={dayjs()}

                                  maxDate={dayjs(selectedmonth, "YYYY-MM").endOf(
                                    "month"
                                  )}
                                  shouldDisableDate={(date) =>
                                    // totalallocation.data[selectedId]?.venueId?.locationType === 'region'
                                    //   ?
                                    //   shouldDisableDate(
                                    //     date,
                                    //     totalallocation.data[selectedId].jobMonth,
                                    //     totalallocation.data[selectedId].jobYear,
                                    //     allocationCriteria?.regionMinDate,
                                    //     allocationCriteria?.regionMaxDate,
                                    //     allocationCriteria?.regionVisitDaysInformation
                                    //   )
                                    //   :
                                    shouldDisableDate(
                                      date,
                                      totalallocation.data[selectedId].jobMonth,
                                      totalallocation.data[selectedId].jobYear,
                                      totalallocation?.data[selectedId]?.minDate,
                                      totalallocation?.data[selectedId]?.maxDate,
                                      totalallocation?.data[selectedId]?.visitDaysInformation
                                    )
                                  }
                                  sx={{
                                    "& .MuiPickersCalendarHeader-switchViewButton":
                                    {
                                      // display: "none",
                                    },
                                    "& .MuiPickersArrowSwitcher-root": {
                                      // display: "none",
                                    },

                                    "& .MuiPickersCalendarHeader-labelContainer":
                                    {
                                      pointerEvents: "none",
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                              <ErrorMessage
                                name="selectedVisitDate"
                                component="div"
                                className="error"
                              />
                              <FormControl fullWidth>
                                <InputLabel
                                  id="demo-simple-select-label"
                                  shrink={false}
                                >
                                  {" "}
                                  <span>
                                    Visiting Time{" "}
                                    <sup>
                                      <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                  </span>
                                </InputLabel>
                                <Select
                                  disabled={allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && formik.values.selectedVisitDate === ""}
                                  labelId="demo-simple-select-label"
                                  aria-placeholder="Select the Time"
                                  value={formik.values.selectedVisitTime}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      "selectedVisitTime",
                                      e.target.value
                                    )
                                  }
                                  MenuProps={{
                                    disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                  }}
                                >
                                  {filtervalue?.map((option, index) => (
                                    <MenuItem
                                      key={index}
                                      value={option.visitTimeId}
                                    >
                                      {option.visitTimeInformation}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <ErrorMessage
                                name="selectedVisitTime"
                                component="div"
                                className="error"
                              />
                            </Box>
                            {/* <p>{ totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId}</p> */}
                            <Button
                              fullWidth
                              className="button-primary mt-4"
                              // disabled={!formik.values.selectedVisitDate || !formik.values.selectedVisitTime}
                              // onClick={handleApplyTaskClick}
                              onClick={async () => {
                                // if(!formik.values.selectedVisitDate || !formik.values.selectedVisitTime){
                                //   return
                                // }
                                await getBrief(
                                  totalallocation?.data[selectedId]?.venueId?.venueId,
                                  totalallocation?.data[selectedId]?.clientEntityId?.clientEntityId
                                );

                                if (
                                  allocationCriteria?.isQuizRequired &&
                                  !allocationCriteria?.isNewBriefSetup
                                ) {
                                  await handleOpenQuiz(
                                    totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId,
                                    totalallocation?.data[selectedId]?.venueId?.venueId,
                                  );
                                } else {
                                  handleApplyTaskClick();
                                }
                              }}
                            >
                              {allocationCriteria?.isQuizRequired ? "Take Quiz" : "Apply Task"}
                            </Button>
                          </Box>
                          <Dialog open={OpenQuiz}>
                            <DialogContent>
                              <Box className="d-flex justify-content-end">
                                <IconButton onClick={() => { setOpenQuiz(false); }}><CancelOutlined /></IconButton>
                              </Box>
                              {QuizList && QuizList.map((item, index) => (
                                <Box className='mb-3'>
                                  <Box className="d-flex mb-0" gap={1}>
                                    <span className="fw-bold">Q{index + 1}.</span>
                                    <div className="mb-0 quiz" key={index} dangerouslySetInnerHTML={{ __html: item.question_text }} />
                                  </Box>
                                  <FormControl>
                                    <RadioGroup
                                      aria-labelledby="demo-radio-buttons-group-label"
                                      value={selectedOptions[index]?.SelectedAnswer}
                                      name="radio-buttons-group"
                                      onChange={(e) => {
                                        const updatedOptions = [...selectedOptions];
                                        updatedOptions[index] = {
                                          ...updatedOptions[index],
                                          SelectedAnswer: parseInt(e.target.value)
                                        };
                                        setSelectedOptions(updatedOptions);
                                        // console.log("Updated Options", updatedOptions);
                                      }}

                                    >
                                      {JSON.parse(item.options).map((option, index) => (
                                        <FormControlLabel value={parseInt(option.option_id)} control={<Radio />} label={option.option_label} />
                                      ))}
                                    </RadioGroup>
                                  </FormControl>
                                </Box>
                              ))}
                              <Button
                                className="button-primary px-4 py-2 ml-auto"
                                onClick={() => {
                                  let correct = 0;
                                  selectedOptions.map(item => {
                                    if (item.SelectedAnswer === item.answer) {
                                      correct++;
                                    }
                                  })
                                  handleOpenQuiz(totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId, totalallocation?.data[selectedId]?.venueId?.venueId)
                                  if (correct === selectedOptions.length) {
                                    setIsQuizSubmitted(true)
                                    handleApplyTaskClick()
                                    // formik.handleSubmit()
                                  }
                                  else {
                                    toast.success(`${correct}/${selectedOptions.length} Are Corrected`)

                                  }
                                }}
                              >
                                Submit
                              </Button>
                            </DialogContent>
                          </Dialog>
                          <Dialog open={OpenBriefDialog}>
                            <DialogContent>
                              {selectedId !== null && (totalallocation?.data[selectedId] || newBrief) ? (
                                <>
                                  <Box className='d-flex align-items-center justify-content-between mb-2'>
                                    <Typography variant="h5" className="fw-bold">{newBrief?.data[0]?.title}</Typography>
                                    <IconButton
                                      className="ms-auto d-block"
                                      onClick={() => {
                                        handleBriefDialogClose();
                                      }}
                                    >
                                      <CancelOutlined className="fd-2" />
                                    </IconButton>
                                  </Box>
                                  <Box
                                    overflow="auto"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        newBrief?.data?.[0]?.description ||
                                        totalallocation.data[selectedId].venueId
                                          ?.venueDescription || "",
                                    }}
                                  />
                                  <div className="d-flex my-2">
                                    <label className="d-flex align-items-center justify-content-center gap-2">
                                      <input
                                        type="checkbox"
                                        onChange={(e) => { setisConfirmApply(e.target.checked) }}
                                      />
                                      <span>Read & understood</span>
                                    </label>
                                  </div>
                                  <Button
                                    disabled={!isConfirmApply}
                                    className="button-primary mx-auto py-2 px-4 d-block"
                                    onClick={() => {
                                      formik.handleSubmit()
                                    }}
                                    sx={{
                                      "&.Mui-disabled": {
                                        backgroundColor: "#ccc !important",
                                        color: "#666 !important",
                                        cursor: "not-allowed",
                                      },
                                    }}
                                  >
                                    Apply
                                  </Button>
                                </>
                              ) : (
                                <Typography variant="subtitle1">No Data Found</Typography>
                              )}
                            </DialogContent>
                          </Dialog>

                          <div className="full-dilaog">
                            <Dialog open={OpenNewBriefDialog} className="full-dilaog d-flex flex-column" fullScreen>
                              <DialogContent className="p-0" sx={{ flex: 1 }}>
                                {newBrief?.data && (<ReadBrief isVewOnly={false} handleClose={() => setOpenNewBriefDialog(false)} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation?.data[selectedId]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />)}
                              </DialogContent>
                            </Dialog>
                          </div>
                        </Form>
                      )
                    }}
                  </Formik>
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
      {(alignment === 'individual' && (totalallocation?.data?.length) <= 0) && (

        <Box
          className="w-100 d-flex align-items-start pt-5 justify-content-center"
          height={"calc(100vh - 133px)"}
        >
          <Box>
            <Typography
              className="text-center mt-3 fw-bold text-main"
              variant="h4"
            >
              All tasks are currently filled. Check back soon.
            </Typography>
            <Typography
              className="text-center mt-3 fw-bold text-main"
              variant="h6"
            >
              Please click on a <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setOpenPicker(true) }}> month</span> to view future listed jobs, <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setOpenFilter(true) }}> expand your search </span> radius beyond {formik.values.range} km, or explore our <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setAlignment('bulk') }}> bundle tasks.</span>            </Typography>

          </Box>
        </Box>

      )}

      {alignment === 'bulk' && <BulkAllocation selectedbundletask={selectedbundletask} setOpenPicker={setOpenPicker} setOpenFilter={setOpenFilter} setAlignment={setAlignment} date={selectedmonth} openFilter={openFilter} handlesaveFilter={handlesaveFilter} reloadFlag={reloadFlag} selectedentitytype={selectedentitytype} selectedstate={selectedstate} location={location} selectedClient={selectedClient} formValues={formik.values} isTransport={false} />}

      {alignment === 'map' && (
        <Box padding='20px'>
          <Box className='d-flex align-items-end mb-3' gap={3}>
            <FormControl className="col-lg-12 col-9" sx={{ mt: 2 }}>
              <Typography variant="body1" className="form-caption" mb={1}>
                Location <sup style={{ color: "red" }}>*</sup>
              </Typography>
              <TextField
                placeholder="Enter location"
                // key={formik.values.location}
                name="location"
                inputProps={{
                  ref: inputRef,  // Use inputProps instead of inputRef
                }}
                defaultValue={formik.values.location ?? ""}
                // autoComplete="off" // Important: disable browser autocomplete
                onChange={(e) => {
                  formik.setFieldValue("location", e.target.value);
                }}
                // error={
                //   formik.touched.location && Boolean(formik.errors.location)
                // }
                // helperText={
                //   formik.touched.location && formik.errors.location
                // }
                // autoComplete="off"
                size="small"
                sx={{
                  position: "relative",
                  zIndex: 1000,
                  backgroundColor: "white",
                }}
              />
            </FormControl>
            {/* <Button className="button-primary px-3 mb-2 py-1" onClick={() => { getmapallocations() }}>Search</Button> */}
          </Box>


          <Box className='col-lg-12 map-input' position='relative'>

            {/* <LoadScript googleMapsApiKey="AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44"> */}
            <GoogleMap
              mapContainerStyle={containerStyle}
              onLoad={(map) => {
                mapRef.current = map;
                setMapLoaded(true);
              }}
              // center={mapCenter}
              options={{
                gestureHandling: "greedy",
                scrollwheel: true,
                zoomControl: true
              }}
            // zoom={10}
            >
              {totalmapallocations?.map((item, index) => {
                const lat = parseFloat(item?.venueId?.lat);
                const lng = parseFloat(item?.venueId?.long);
                const isHovered = hoveredMarkerIndex === index;

                // Safety check: Only render if lat/lng are valid
                if (isNaN(lat) || isNaN(lng)) return null;
                // if (!item?.bundleId) return;

                return (
                  <Marker
                    key={index}
                    position={{ lat, lng }}
                    // onClick={() => {
                    //   setAlignment('individual');
                    //   selectcard(index);
                    // }}
                    onClick={() => setHoveredMarkerIndex(index)}
                    // onMouseOut={() => setHoveredMarkerIndex(null)}
                    icon={{
                      url:
                        item?.allocationClientGroup === "ALDI"
                          ? "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%281%29.png-2f692b6f-0d3e-49a9-b658-a70e98759edc"
                          : item?.allocationClientGroup === "BLOOMS"
                            ? "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%282%29.png-6f906dfe-d33f-4d74-992e-b180c9f02fd8"
                            : "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6",
                    }}
                  >
                    {isHovered && (
                      <InfoWindow

                        position={{ lat, lng }} // explicitly provide position
                        onCloseClick={() => setHoveredMarkerIndex(null)}
                      >
                        <Box>
                          <Box className='d-flex align-items-center mb-2' gap={2}>
                            <Avatar
                              src={item?.venueId?.logoUrl}

                              sx={{
                                border: '1px solid',
                                padding: '2px',
                                height: "40px",
                                width: "42px",
                                img: {
                                  objectFit: "contain", // ensures the full image fits inside
                                },
                              }}
                            >
                              {(!item?.venueId?.logoUrl && item?.venueId?.venueName?.[0]?.toUpperCase()) || "N"}                              </Avatar>
                            <Typography variant="h5" fontWeight='bold'>{item?.venueId?.venueName}</Typography>
                          </Box>
                          <Box className='d-flex align-items-center mb-2 mt-1' gap={1}>
                            {/* <Typography className="px-2" variant="subtitle2" sx={{ bgcolor: '#ADB7922A', borderRadius: '5px' }}> code: {item?.venueId?.venueCode}</Typography> */}
                            {/* <Typography className="px-2" variant="subtitle2" sx={{ bgcolor: '#ADB7922A', borderRadius: '5px' }}>Group: {item?.venueId?.venueGroup}</Typography> */}
                            <Typography className="px-2" variant="subtitle2" sx={{ bgcolor: '#ADB7922A', borderRadius: '5px' }}>{item?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}</Typography>
                          </Box>
                          <Box className='d-flex flex-column'>
                            <Typography gutterBottom variant="subtitle2">Address:{item?.venueId?.address} {item?.venueId?.city} {item?.venueId?.state} {item?.venueId?.postalCode}</Typography>
                            <Typography gutterBottom variant="subtitle2">PostCode: {item?.venueId?.postalCode}</Typography>
                            <Typography gutterBottom variant="subtitle2">Trade Hours: {item?.venueId?.tradingHours}</Typography>
                            <Typography gutterBottom variant="subtitle2">Website: <a href={item?.venueId?.websiteURL}>{item?.venueId?.websiteURL}</a></Typography>
                            <Typography gutterBottom variant="subtitle2">Price: {item?.allocationPriceDisplay !== "" ? item?.allocationPriceDisplay : "N/A"}</Typography>
                          </Box>
                          <hr />
                          <Button className="button-primary px-3 py-1" onClick={() => {
                            if (!item?.bundleId) {
                              setAlignment('individual');
                              selectcard(index);
                            }
                            else {
                              setAlignment('bulk');
                              setselectedbundleTask(item?.allocationId);
                            }
                          }}>Apply</Button>
                        </Box>

                      </InfoWindow>
                    )}
                  </Marker>
                );
              })}
              {/* <Marker position={markerPosition} /> */}
            </GoogleMap>
            {/* </LoadScript> */}
          </Box>
        </Box>
      )}


      {loading && <Loading />}
      <Drawer
        anchor="right"
        className="col-12"
        open={openFilter}
        onClose={() => setOpenFilter(false)}
      >
        <form onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default Enter behavior
          }
        }} onSubmit={formik.handleSubmit}>
          <Box
            className="d-flex flex-column w-100 px-4 py-3"
            height="100vh"
            bgcolor="white"
          >
            <Box className="flex-grow-1">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Typography variant="h5" className="fw-bold">
                  Filters
                </Typography>
                <IconButton onClick={() => setOpenFilter(false)}>
                  <CancelOutlined />
                </IconButton>
              </Box>

              <Divider
                sx={{
                  my: 2,
                  borderColor: "#00000033",
                  border: "1px solid #00000033",
                  width: "100%",
                }}
              />

              <Typography
                variant="body1"
                className="form-caption"
                sx={{ mb: 1 }}
              >
                Select Any One from below to begin with:
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                // value={selectedRadio}
                // onChange={handleRadioChange}
                {...formik.getFieldProps("filterOption")}
              >
                <FormControlLabel
                  value="myHome"
                  control={<BpRadio />}
                  label="My Home"
                />
                <FormControlLabel
                  value="nearMe"
                  control={<BpRadio />}
                  label="Near Me"
                />
                <FormControlLabel
                  value="manual"
                  control={<BpRadio />}
                  label="Manual"
                />
              </RadioGroup>
              {formik.values.filterOption === "manual" && (
                <>
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <Typography variant="body1" className="form-caption" mb={1}>
                      Location <sup style={{ color: "red" }}>*</sup>
                    </Typography>
                    <TextField
                      placeholder="Enter location"
                      name="location"
                      inputProps={{
                        ref: inputRef,  // Use inputProps instead of inputRef
                      }}
                      defaultValue={formik.values.location ?? ""}
                      onBlur={formik.handleBlur}
                      // onChange={(e) => {
                      //   formik.setFieldValue("location", e.target.value);
                      // }}
                      error={
                        formik.touched.location && Boolean(formik.errors.location)
                      }
                      helperText={
                        formik.touched.location && formik.errors.location
                      }
                      autoComplete="off"
                      sx={{
                        position: "relative",
                        zIndex: 1000,
                        backgroundColor: "white",
                      }}
                    />
                  </FormControl>
                </>

              )}

              <Typography variant="body1" className="form-caption" mt={3}>
                Select Range:
              </Typography>
              <Box className="w-100 d-flex align-items-center justify-content-center">
                <CustomSlider
                  // value={range}
                  // onChange={(event, newValue) => setRange(newValue as number)}
                  min={0}
                  max={300}
                  step={1}
                  marks={marks}
                  valueLabelDisplay="on"
                  valueLabelFormat={(value) => `${value} km`}
                  {...formik.getFieldProps("range")}
                />
              </Box>

              {/* <Typography sx={{ fontSize: "16px", fontWeight: "bold", mt: 1 }}>
                            {range} km
                        </Typography> */}
              <Box display="flex" alignItems="center" width="100%" my={2}>
                <Box flex={1} height="1px" bgcolor="#00000033" />

                <Typography variant="body1" mx={2} color="gray">
                  or
                </Typography>

                <Box flex={1} height="1px" bgcolor="#00000033" />
              </Box>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Client{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  aria-placeholder="Select the Time"
                  value={selectedClient}
                  onChange={(e) => {
                    setselectedClient(e.target.value);
                    formik.setFieldValue("venue", '');
                    formik.setFieldValue("venueId", null);
                  }}
                  MenuProps={{
                    disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                  }}
                >
                  <MenuItem value='all'>All</MenuItem>
                  {clientList?.map((option, index) => (
                    option?.clientGroupName !== "TRANSPORT" && (
                      <MenuItem key={index} value={option?.clientGroupName}>
                        {option?.clientGroupName}
                      </MenuItem>
                    )
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Task Type{" "}

                  </span>
                </InputLabel>
                <Autocomplete
                  disablePortal
                  value={
                    entitytypelist.find((option) => option?.entityTypeId === selectedentitytype) || null
                  }
                  options={entitytypelist}
                  getOptionLabel={(option: any) => option?.entityTypeName}
                  renderInput={(params) => <TextField  {...params} />}
                  onChange={(event, newValue) => {
                    setselectedentitytype(newValue?.entityTypeId)
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select State{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Autocomplete
                  disablePortal
                  value={
                    statelist.find((option) => option?.state === selectedstate) || null
                  }
                  options={statelist}
                  getOptionLabel={(option: any) => option?.state}
                  renderInput={(params) => <TextField  {...params} />}
                  onChange={(event, newValue) => {
                    formik.values.filterOption = ''
                    formik.values.range = ''
                    setselectedestate(newValue?.state)
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Venue{" "}

                  </span>
                </InputLabel>
                <Autocomplete
                  disablePortal
                  value={
                    filteredVenues.find(
                      (option) => Number(option.venueId) === formik.values.venueId
                    ) || null
                  } options={filteredVenues}
                  getOptionLabel={(option: any) => option?.venueName || ""}
                  renderInput={(params) => <TextField  {...params} />}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      setsearchvenue(newInputValue);
                    }
                  }} isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("venueId", newValue?.venueId || "");
                    formik.setFieldValue("venue", newValue?.venueName || "");
                  }} />
              </FormControl>
              {/* <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Venue{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  aria-placeholder="Select the Time"
                  value={formik.values.venueId}
                  onChange={(e) => {
                    const selectedVenueId = e.target.value;
                    const selectedVenue = filteredVenues.find(venue => venue.venueId === selectedVenueId);
                    formik.setFieldValue("venueId", selectedVenueId);
                    formik.setFieldValue("venue", selectedVenue?.venueName || "");
                  }}
                  MenuProps={{
                    disablePortal: false,
                  }}
                >
                  {filteredVenues?.map(
                    (option, index) =>
                    (
                      <MenuItem key={index} value={option?.venueId}>
                        {option?.venueName}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl> */}
            </Box>
            <Button
              variant="contained"
              className="button-primary mt-5"
              fullWidth
              type="submit"
            >
              Apply Filters
            </Button>
          </Box>
        </form>
      </Drawer>
      <Dialog open={OpenDialog}>
        <DialogContent>
          {selectedId !== null && (totalallocation?.data[selectedId] || newBrief) ? (
            <>
              <Box className='d-flex align-items-center justify-content-between mb-2'>
                <Typography variant="h5" className="fw-bold">{newBrief?.data?.[0]?.title}</Typography>
                <IconButton
                  className="ms-auto d-block"
                  onClick={() => {
                    handleDialogClose();
                  }}
                >
                  <CancelOutlined className="fd-2" />
                </IconButton>
              </Box>
              <Box
                overflow="auto"
                dangerouslySetInnerHTML={{
                  __html: newBrief?.data?.[0]?.description ||
                    totalallocation.data[selectedId].venueId
                      ?.venueDescription || "",
                }}
              />
              <Button
                className="button-primary mx-auto py-2 px-4 d-block"
                onClick={() => {
                  handleDialogClose();
                }}
              >
                Continue
              </Button>
            </>
          ) : (
            <Typography variant="subtitle1">No Data Found</Typography>
          )}
        </DialogContent>
      </Dialog>
      <div className="full-dilaog">
        <Dialog open={OpenNewBriefReadDialog} className="full-dilaog d-flex flex-column" fullScreen>
          <DialogContent className="p-0" sx={{ flex: 1 }}>
            {OpenNewBriefReadDialog && newBrief?.data && (<ReadBrief isVewOnly={true} handleClose={() => { setOpenNewBriefReadDialog(false) }} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation?.data[selectedId]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />)}
          </DialogContent>
        </Dialog>
      </div>
      <Dialog open={openInfo}>
        <DialogContent>
          <Typography variant="h6">
            Before applying for this task, please read the brief and complete a short knowledge check. Once you've passed, you won't need to take it again unless the brief changes.
          </Typography>
          <Box className='d-flex align-items-center gap-2 justify-content-center'>
            <Button className="button-primary-outlined py-1 px-3" variant="outlined" onClick={() => { setOpenInfo(false) }}>Cancel</Button>
            <Button className="button-primary py-1 px-3" onClick={() => { setOpenInfo(false); setOpenNewBriefDialog(true) }}>Continue</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default ApplyTask;
